import * as Constants from '../constants/';

const initialState = {
  isLoading: false,
  error: null,
  data: {
    tags: []
  }
};

export default function(state = initialState, action) {
  switch (action.type) {
    case Constants.REQUEST_CREATE_TAGS:
      return { ...state, error: null, isLoading: true };
    case Constants.CLEAR_TAGS:
      return { ...state, error: null, data: { tags: [] } };
    case Constants.RECEIVE_CREATE_TAGS:
      if (action.error) {
        return { ...state, isLoading: false, error: action.error };
      }
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          tags: [...action.data?.tags]
        }
      };
    default:
      return state;
  }
}
